import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import * as StyleUtils from 'Utils/StyleUtils';
export function Grid(props) {
    return (React.createElement("div", { className: StyleUtils.mergeClassNames('ag-theme-quartz-dark', props.className) },
        React.createElement(AgGridReact, { columnDefs: props.columnDefinitions, rowData: props.rowData })));
}
